import React, { useEffect, useState } from 'react'
import { Text, TouchableOpacity, View, ScrollView } from 'react-native'
import { FormContentsModel, FormFieldsModel, ModelAnswerFromProps } from '../models/StoreDetailModel'
import theme from '../../../../theme'
import styles from './SiNoNaItemStyles'
import { FieldsView } from '../FieldsView'
import { placeholderGeneral } from '../../customUtils/Constants'
import { Feather } from '@expo/vector-icons'
import { schedulesServices } from '../../../../database/schedules.database'
import { updateFormAnswerSchedule } from '../../../../db-sqlite/repositories/schedule.repository'
import { useBottomSheet } from '../../customUtils/context/BottomSheetContext'
import { ImageWithZoom } from '../../customUtils/Components/ImageWIthZoom'
import { StatusBar } from 'react-native'
import useImageLoader from '../../../hooks/useImageLoader'
import { PATH_ASSETS } from '../../../utils/Constants'
import { Loader } from '../../customUtils/Components/Loader'
import { Image } from 'expo-image'

const contentYesNoNasRoutes = {
    yes: require('../../../../assets/stores/yesOutlined.png'),
    yesFilled: require('../../../../assets/stores/yesFilled.png'),
    no: require('../../../../assets/stores/noOutlined.png'),
    noFilled: require('../../../../assets/stores/noFilled.png'),
}

interface SiNoNaItemProps {
    item: FormContentsModel
    hideOrShow: (hides?: string[], show?: string[], data?: FormContentsModel[]) => void
    form_id: string
    schedule_id: string
    store_id: string
    checkComplete: (option?: ModelAnswerFromProps) => void
    data: FormContentsModel[]
    name_form?: string
    keyboardHiddenState: boolean
    onFocus: (id: string) => void
    activeInputId: string
}

export const SiNoNaItem = React.memo(
    ({
        item,
        hideOrShow,
        form_id,
        schedule_id,
        store_id,
        checkComplete,
        data,
        name_form,
        keyboardHiddenState,
        onFocus,
        activeInputId,
    }: SiNoNaItemProps) => {

        const [selectedIndex, setSelectedIndex] = useState(-1)
        const [fields, setFields] = useState<{ fields: FormFieldsModel[]; answer: ModelAnswerFromProps | null }>({ fields: [], answer: null })
        const { openBottomSheet } = useBottomSheet()

        const { image, loading, placeholderGeneral } = useImageLoader(item.media, PATH_ASSETS)
        const [preview, setPreview] = useState(image)

        // Agrega _id sintético a los fields que no lo tienen (datos del backend sin _id).
        // Formato: "{item._id}_{action._id}_{fieldIndex}" → único y estable por pregunta.
        const withSyntheticIds = (rawFields: FormFieldsModel[], actionId: string) =>
            rawFields.map((field, idx) => ({
                ...field,
                _id: field._id ?? `${item._id}_${actionId}_${idx}`,
            }))

        useEffect(() => {
            setPreview(image)
        }, [image])
        useEffect(() => {
            //  console.log('estoy en el efect del old response', item.input_type, item?.old_response)

            if (item?.old_response) {
                const option_selected_id = item.old_response.option_selected_id[0]

                const findIndex = item.secondary_actions.findIndex((action) => action._id === option_selected_id)

                if (findIndex !== -1) {
                    setSelectedIndex(findIndex)
                }

                if (item.old_response.field_text != '' || item.old_response.field_media != '') {
                    setFields({
                        fields: withSyntheticIds(
                            item.secondary_actions[findIndex].fields ?? [],
                            item.secondary_actions[findIndex]._id,
                        ),
                        answer: item.old_response,
                    })
                }

                // ✅ RESTAURADO: Type 14 (yes_no_open) SÍ puede tener hide/show en botones
                if (item.input_type.type === 14 && findIndex !== -1) {
                    const selectedAction = item.secondary_actions[findIndex]
                    const hasHideQuestions = selectedAction.hide_questions && selectedAction.hide_questions.length > 0
                    const hasShowQuestions = selectedAction.show_questions && selectedAction.show_questions.length > 0
                    if (hasHideQuestions || hasShowQuestions) {
                        hideOrShow(
                            selectedAction.hide_questions || [],
                            selectedAction.show_questions || [],
                            data,
                        )
                    }
                }
            } else {
            }
        }, [item?.old_response])

        const updatingAnswer = async (answer, schedule_id, form_id, store_id) => {
            try {
                await updateFormAnswerSchedule({ newAnswer: answer, schedule_id, form_id, store_id })
                return true
            } catch (error) {
                console.error('updatingAnswer => ', error)
                return false
            }
        }

        const onClick = async (index: number, sheet: boolean) => {
            //console.log('====>selecciono una opcion:', item.secondary_actions[index])
            try {
                let answer: ModelAnswerFromProps = {
                    _id: item._id,
                    option_selected_text: [item.secondary_actions[index].label],
                    option_selected_id: [item.secondary_actions[index]._id],
                    question_id: item._id,
                    media: '',
                    question_text: item.title,
                    score: item.secondary_actions[index].score ? item.secondary_actions[index].score.toString() : '0',
                    status: 1,
                    date_finish: new Date().toString(),
                    date_init: new Date().toString(),
                    question_input: '',
                    index: index,
                    field_media: '',
                    //field_text: '100',
                    questionScore: item.questionScore,
                    type: item.input_type.type,
                    ponderar: item.questionScore && item.questionScore > 0, // [7, 8, 14, 18].includes(item.input_type.type),

                    question: item.title,
                    questionOptionSelected: [item.secondary_actions[index]._id],
                    questionOptionSelectedText: [item.secondary_actions[index].label],
                    questionType: {
                        title: item.input_type.title,
                        type: item.input_type.type,
                        id: item.input_type._id,
                    },
                    questionPrice: '',
                    tag: '',
                    questionImage: '',
                    questionInput: '',
                    sku: item.sku,
                    description: item.description ?? '',
                    description_short: item.description_short ?? '',
                }
                let fields = {
                    fields: withSyntheticIds(
                        item.secondary_actions[index].fields ?? [],
                        item.secondary_actions[index]._id,
                    ),
                    answer: answer,
                }

                setFields(fields)

                // tengo sub

                if (item.secondary_actions[index].fields && item.secondary_actions[index].fields.length > 0) {
                    let showData = true
                    let showOptions = true
                    if (!sheet) {
                        if (fields.fields.some((field) => field.type?.type === 4 || field.type?.type === 33 || field.type?.type === 32)) {
                            showData = false
                            showOptions = false
                        }
                        if (fields.fields.some((field) => field.type?.type === 15)) {
                            showData = false
                            showOptions = false
                        }
                        // console.log('Fields', item.secondary_actions[index])
                    }
                    // openSheet(index, fields, showData, showOptions)
                    console.log('✅ [SiNoNa] Botón con fields - Guardando respuesta inicial antes de mostrar campos adicionales')
                    
                    // ✅ FIX: SIEMPRE guardar la respuesta inicial, incluso si tiene fields
                    // Esto permite que la validación reconozca que la pregunta fue respondida
                    // Luego FieldsView actualizará field_text/field_media cuando el usuario los complete
                    const result = await updatingAnswer(answer, schedule_id, form_id, store_id)
                    if (result) {
                        checkComplete(answer)
                        setSelectedIndex(index)
                        console.log('✅ [SiNoNa] Respuesta inicial guardada, mostrando FieldsView para completar campos adicionales')
                    } else {
                        console.error('❌ [SiNoNa] Error al guardar respuesta inicial')
                    }
                } else {
                    //console.log('999999  estpy en el else de la funcion sino na item')
                    // console.log('🚀 ~ onClick ~ update_op => ', answer._id)
                    // const result = await schedulesServices.updateFormAnswerSchedule(answer, schedule_id, form_id, store_id)
                    const result = await updatingAnswer(answer, schedule_id, form_id, store_id)
                    // console.log("156 ===> 🚀 ~ onClick ~ result:", result)
                    if (result) {
                        checkComplete(answer)
                        setSelectedIndex(index)
                    }

                    // ✅ RESTAURADO: Type 14 (yes_no_open) SÍ tiene lógica de hide/show
                    // Solo los types 7, 8, 18 (botones simples) NO tienen hide_questions/show_questions
                    if (item.input_type.type === 14) {
                        const selectedAction = item.secondary_actions[index]
                        const hasHideQuestions = selectedAction.hide_questions && selectedAction.hide_questions.length > 0
                        const hasShowQuestions = selectedAction.show_questions && selectedAction.show_questions.length > 0
                        
                        if (hasHideQuestions || hasShowQuestions) {
                            hideOrShow(
                                selectedAction.hide_questions || [],
                                selectedAction.show_questions || [],
                                data,
                            )
                        }
                    }
                }

                // setSelectedIndex(index)
                //  await schedulesServices.updateFormAnswerSchedule(answer, schedule_id, form_id, store_id)

                // await checkComplete(answer)
            } catch (error) {
                console.error('onClick => ', error)
            }
        }

        const openSheet = (
            index: number,
            fields: { fields: FormFieldsModel[]; answer: ModelAnswerFromProps | null },
            showData: boolean,
            showOptions: boolean,
        ) => {
            let newFields = { fields: [], answer: null }
            if (item.old_response) {
                if (item.old_response.field_text !== '' || item.old_response.field_media !== '') {
                    const oldAction = item.secondary_actions[item.old_response.index]
                    newFields = {
                        fields: withSyntheticIds(oldAction.fields ?? [], oldAction._id),
                        answer: item.old_response,
                    }
                } else {
                    newFields = fields
                }
            } else {
                newFields = fields
            }
            setFields(newFields)
        }
        const openBigImage = () => {
            if (image) {
                openBottomSheet(<ImageWithZoom uri={image} contentSeen={() => {}} path={''} />, undefined, undefined, true, true, true)
            }
        }
        return (
            <View style={styles.container}>
                <View style={styles.containerItem}>
                    {item.media && (
                        <TouchableOpacity onPress={() => openBigImage()}>
                            {loading ? <Loader /> : <Image style={styles.image} source={{ uri: preview }} key={preview} />}
                        </TouchableOpacity>
                    )}

                    <View style={styles.containerData}>
                        {item.title && <Text style={styles.title}>{item.title}</Text>}
                        {item.description_short && <Text style={styles.description_short}>{item.description_short}</Text>}
                        {item.ean && <Text style={styles.ean}>{item.ean}</Text>}
                        {item.description && <Text style={styles.description}>{item.description}</Text>}
                    </View>

                    <View>
                        <View style={styles.flexDirectionRow}>
                            {item.secondary_actions &&
                                item.secondary_actions.map((action, index) => {
                                    const isSelected = selectedIndex === index
                                    if (action.label === 'na') {
                                        return null
                                    }
                                    return (
                                        <SiNoNaButton
                                            key={`yesno-${action._id.toString()}`}
                                            name={action.label}
                                            index={index}
                                            onClickTag={(id) => onClick(id, false)}
                                            isSelected={isSelected}
                                        />
                                    )
                                })}
                        </View>

                        {item.secondary_actions &&
                            item.secondary_actions.map((action, index) => {
                                const isSelected = selectedIndex === index
                                if (action.label == 'na') {
                                    return (
                                        <SiNoNaButton
                                            key={`na-${action._id.toString()}`}
                                            name={action.label}
                                            index={index}
                                            onClickTag={(id) => onClick(id, false)}
                                            isSelected={isSelected}
                                        />
                                    )
                                }
                                return null
                            })}
                        {/* BOTÓN EDITAR 
                    {item.secondary_actions &&
                        item.secondary_actions.map((action, index) => {
                            const isSelected = selectedIndex === index
                            if (action.label == 'na') {
                                return <EditPriceButton name={action.label} index={index} onClickTag={onClick} isSelected={isSelected} />
                            }
                        })}
                    */}
                    </View>
                </View>
                {fields.fields.length > 0 && (
                    <FieldsView
                        fields={fields.fields}
                        form_id={form_id}
                        schedule_id={schedule_id}
                        store_id={store_id}
                        answerProp={fields.answer}
                        closeBottomSheet={() => {}}
                        checkComplete={checkComplete}
                        keyboardHiddenState={keyboardHiddenState}
                        onFocus={onFocus}
                        activeInputId={activeInputId}
                    />
                )}
                {/* <View style={styles.dividerHorizontalLine}></View> */}
            </View>
        )
    },
)

interface SiNoNaButtonProps {
    name: string
    index: number
    onClickTag: (id: number) => void
    isSelected: boolean
}

export const SiNoNaButton = ({ name, index, onClickTag, isSelected }: SiNoNaButtonProps) => {
    return (
        <View>
            {name === 'na' ? (
                <TouchableOpacity
                    onPress={() => onClickTag(index)}
                    style={[
                        styles.containerMiniButton,
                        { borderColor: theme.colors.darkGray, backgroundColor: isSelected ? theme.colors.darkGray : 'transparent' },
                    ]}
                >
                    <Text style={isSelected ? styles.textButtonNASelected : styles.textButtonNAUnselected}>No aplica</Text>
                </TouchableOpacity>
            ) : (
                <TouchableOpacity onPress={() => onClickTag(index)} style={styles.containerYesNo}>
                    <Image style={styles.imageYesNo} source={contentYesNoNasRoutes[isSelected ? name + 'Filled' : name]} />
                </TouchableOpacity>
            )}
        </View>
    )
}

export const SiNoNaButtonPro = ({ name, index, onClickTag, isSelected }: SiNoNaButtonProps) => {
    return name === 'na' ? (
        <TouchableOpacity
            onPress={() => onClickTag(index)}
            style={isSelected ? styles.containerMiniButtonBisSelected : styles.containerMiniButtonBisUnselected}
        >
            <Text style={isSelected ? styles.textButtonNASelectedBis : styles.textButtonNAUnselectedBis}>No aplica</Text>
        </TouchableOpacity>
    ) : (
        <TouchableOpacity
            style={[
                styles.containerYesNoButton,
                {
                    borderColor: name === 'yes' ? theme.colors.colorApproved : theme.colors.colorDisapproved,
                    backgroundColor:
                        name === 'yes' && isSelected
                            ? theme.colors.colorApproved
                            : name === 'no' && isSelected
                            ? theme.colors.colorDisapproved
                            : 'transparent',
                },
            ]}
            onPress={() => onClickTag(index)}
        >
            <Feather
                name={name === 'yes' ? 'check' : 'x'}
                size={18}
                color={isSelected ? 'white' : name === 'yes' ? theme.colors.colorApproved : theme.colors.colorDisapproved}
                style={{ alignSelf: 'center' }}
            />
        </TouchableOpacity>
    )
}

interface EditPriceButtonProps {
    name: string
    index: number
    onClickTag: (id: number) => void
    isSelected: boolean
}
export const EditPriceButton = ({ name, index, onClickTag, isSelected }: EditPriceButtonProps) => {
    return (
        <TouchableOpacity onPress={() => console.log('')} style={styles.containerTextIcon}>
            <Feather name='edit-2' size={18} color={theme.colors.colorPrimary} />
            <Text style={styles.textButton}>EDITAR</Text>
        </TouchableOpacity>
    )
}

export const SiNoNaSheet = ({
    item,
    onClickTag,
    prevFields,
    prevIndex,
    form_id,
    schedule_id,
    store_id,
    closeBottomSheet,
    showData,
    showOptions,
    formTitle,
}: {
    item: FormContentsModel
    onClickTag: (id: string, data?: FormContentsModel[]) => void
    prevFields: { fields: FormFieldsModel[]; answer: ModelAnswerFromProps | null }
    prevIndex: number
    form_id: string
    schedule_id: string
    store_id: string
    closeBottomSheet: (l) => void
    showData: boolean
    showOptions: boolean
    formTitle?: string
}) => {
    const [selectedIndex, setSelectedIndes] = useState(prevIndex)
    const [fields, setFields] = useState<{ fields: FormFieldsModel[]; answer: ModelAnswerFromProps | null }>({
        fields: prevFields.fields,
        answer: prevFields.answer,
    })
    const [showInfo, setShowInfo] = useState(showData)
    const [updateShowOptions, setUpdateShowOptions] = useState(showOptions)

    useEffect(() => {
        setFields({ fields: prevFields.fields, answer: prevFields.answer })
    }, [prevFields])

    const onClick = async (index: number) => {
        setSelectedIndes(index)
        onClickTag(index.toString())
        const answer: ModelAnswerFromProps = {
            _id: item._id,
            option_selected_text: [item.secondary_actions[index].label],
            option_selected_id: [item.secondary_actions[index]._id],
            question_id: item._id,
            media: '',
            question_text: item.title,
            score: '0',
            status: 1,
            date_finish: new Date().toString(),
            date_init: new Date().toString(),
            question_input: '',
            index: index,
            field_media: '',
            field_text: '',
            questionScore: item.questionScore,
            type: item.input_type.type,
            ponderar: item.questionScore && item.questionScore > 0, //[7, 8, 14, 18].includes(item.input_type.type),

            question: item.title,
            questionOptionSelected: [item.secondary_actions[index]._id],
            questionOptionSelectedText: [item.secondary_actions[index].label],
            questionType: {
                title: item.input_type.title,
                type: item.input_type.type,
                id: item.input_type._id,
            },
            questionPrice: '',
            description: '',
            tag: '',
            questionImage: '',
            questionInput: '',
        }
        const action = item.secondary_actions[index]
        let fields = {
            fields: (action.fields ?? []).map((field, idx) => ({
                ...field,
                _id: field._id ?? `${item._id}_${action._id}_${idx}`,
            })),
            answer: answer,
        }

        if (action.fields && action.fields.length > 0) {
            setFields(fields)
            setShowInfo(false)
            setUpdateShowOptions(false)
        } else {
            setFields({ fields: [], answer: null })
            await updateFormAnswerSchedule({ newAnswer: answer, schedule_id, form_id, store_id })
        }
    }

    return (
        <View style={styles.containerFlex}>
            {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}
            <View style={styles.containerFlex}>
                {showInfo && (
                    <>
                        <View style={styles.alignCenter}>
                            {formTitle && <Text style={styles.formTitle}>{formTitle}</Text>}
                            {item.title && <Text style={styles.itemTitle}>{item.title}</Text>}
                        </View>
                        <View style={styles.alignCenter}>
                            {item.media && <ImageWithZoom uri={item.media ? item.media : placeholderGeneral} contentSeen={() => {}} path={''} />}
                            {item.description && <Text style={styles.description}>{item.description}</Text>}
                        </View>
                    </>
                )}

                <View style={styles.marginTopBottom}>
                    <View style={styles.containerRowCenter}>
                        {updateShowOptions &&
                            item.secondary_actions &&
                            item.secondary_actions.map((action, index) => {
                                const isSelected = selectedIndex === index

                                return (
                                    <SiNoNaButtonPro
                                        key={action._id.toString()}
                                        name={action.label}
                                        index={index}
                                        onClickTag={onClick}
                                        isSelected={isSelected}
                                    />
                                )
                            })}
                    </View>
                </View>
                <View style={styles.containerFlex}>
                    {/* {fields.fields.length > 0 && (
                        <FieldsView
                            fields={fields.fields}
                            form_id={form_id}
                            schedule_id={schedule_id}
                            store_id={store_id}
                            answerProp={fields.answer}
                            closeBottomSheet={closeBottomSheet}
                            checkComplete={() => {}}
                        />
                    )} */}
                </View>
            </View>
        </View>
    )
}
